module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-11-min.c18b6c17.jpg";